import Joyride, { CallBackProps, STATUS, Step } from "react-joyride";
import { GuidedTourTooltip } from "./components/GuidedTourTooltip";
import { useTheme } from "@emotion/react";
import { useGuidedTourLogic } from "./useGuidedTourLogic";
import { useBreakpoint } from "@avenue-8/sidekick-ui";

export const OnboardingGuidedTour = () => {
  const { isOnboardingTourRunning, completeTour } = useGuidedTourLogic();
  const theme = useTheme();
  const isMobile = useBreakpoint("mobile");

  const steps: Step[] = [
    {
      target: "#sidekick-message-bar-input",
      title: "Chat with Sidekick",
      content:
        "Continue the conversation! Type your questions, needs and goals with Sidekick here.",
      placement: isMobile ? "top-end" : "top",
      disableScrolling: true,
      spotlightPadding: 8,
      disableBeacon: true,
    },
    {
      target: "#sidekick-message-bar-attachment-button",
      title: "Attach Files",
      content:
        "Upload photos or documents for Sidekick to analyze and summarize.",
      placement: "top",
      disableScrolling: true,
      spotlightPadding: 8,
    },
    {
      target: "#thread-header-actions-button",
      title: "Manage This Chat",
      content:
        "Click here to pin this chat, delete it, or reach out for support.",
      placement: "auto",
      disableScrolling: true,
      disableBeacon: true,
      spotlightPadding: 4,
      hideBackButton: true,
    },
  ];

  const handleJoyrideCallback = (data: CallBackProps) => {
    const { status } = data;

    if (STATUS.FINISHED === status || STATUS.SKIPPED === status) {
      completeTour();
    }
  };

  return (
    <Joyride
      steps={steps}
      run={isOnboardingTourRunning}
      continuous
      showProgress
      disableOverlayClose
      disableCloseOnEsc
      spotlightPadding={8}
      callback={handleJoyrideCallback}
      tooltipComponent={GuidedTourTooltip}
      styles={{
        options: {
          arrowColor: theme.colors.background,
          overlayColor: "rgba(0, 0, 0, 0.5)",
        },
        spotlight: {
          borderRadius: 8,
        },
      }}
    />
  );
};
